const API_URL = process.env.REACT_APP_API_URL;
const OLD_API_URL = process.env.REACT_APP_OLD_API_URL || process.env.REACT_APP_API_URL;  // fall back if old isn't provided

// api-v2 (Django/Lambda) base URL — used by Helpers/uploadViaPresign.js
// for direct-to-S3 image uploads. Trailing slash trimmed so callers can
// `${API_V2_URL}/api/...`.
export const API_V2_URL = (process.env.REACT_APP_API_V2_URL || "").replace(/\/$/, "");

// All legacy upload/print routes now flow through API_URL (Lambda-legacy).
//   utils/upload-image: replaced by api-v2 presign+S3 PUT (see uploadViaPresign).
//   orders/designer/print-message + orders/mass-print-message: handled by
//     Path A inline-bytes (api PR #228) — the openPrintMessage helper consumes
//     either message_base64 or message_url.
const OLD_API_PATHS = [];

export const getAPIURL = (path) => {
  const baseURL = OLD_API_PATHS.includes(path) ? OLD_API_URL : API_URL;
  return baseURL + path;
};
